export interface QuickPayInfo {
  acct_type: string;
  email: string;
  firstName: string;
  middleInitial: string;
  lastName: string;
  zipCode: string;
  authenticated: boolean;
  securityQuestionSetupFlag: boolean;
  partiId: string;
  noteId: number;
  relationshipType: string;
  sessionToken: any;
  sessionCreateDate: Date;
  sessionLastActiveDate: Date;
  sessionTimeout: boolean;
}
export interface IpAddress {
  ip: string;
 }

export interface QuickPayRequest {
  acct_type: string;
  partiId: string;
  lastName: string;
  zipCode: string;
  retryCount: number;
  lockedOutFlag: boolean;
  activeFlag: boolean;
  multifactorEligible: boolean;
  multifactorEnabled: boolean;
  multifactorGracePeriod: number;
  lastVerifiedIpAddress: string;
  lastVerifiedOTP: Date;
  multifactorRetryCount: number;
}

export interface QuickPayUserInformation {
  acct_type: string;
  partiId: number;
  firstName: string,
  middleInitial: string,
  lastName: string,
  zipCode: string;
  retryCount: number;
  lockedOutFlag: boolean;
  activeFlag: boolean;
  multifactorEligible: boolean;
  multifactorEnabled: boolean;
  multifactorGracePeriod: number;
  lastVerifiedIpAddress: string;
  lastVerifiedOTP: Date;
  multifactorRetryCount: number;
  stdNum_count: number;
  note_count: number;
}
export interface OpenNotesQuickPayPaymentInfoListItem {
  participantId: string;
  noteId: number;
  lastName: string,
  zipCode: string,
  paymentDueDay: number;
  loanProgram: string;
  paymentGroup: string;
  loanCode: string;
  minimumAmountDue: number;
  totalAmountDue: number;
  noteState: string;
  sortOrder: number;
}

export interface OpenNotesQuickPayPaymentInfoListGroupFooter {
  isGroupFooter: boolean;
  paymentGroup: string;
  totalAmountDueTotal: number;
}

export interface CreditCardPaymentInformation {
  participantId: string;
  companyCode: string;
  noteIds: string;
  paymentAmount: number;
  paymentDueDay: number;
  loanProgram: string;
  servicingCompany: string;
  fullName: string;
  addressLine1: string;
  city: string;
  state: string;
  zipCode: string;
  userName: string;
  paymentRef: string;
  paymentType: number;

  /* From Braintree tokenized payload */
  nonce: string;
  partiFirstName: string;
  partiLastName: string;
  partiEmail: string;
  deviceData: string;
  creditCardBin: string;
  creditCardType: string;
  lastFourCreditCard: string;
  creditCardExpMonth: string;
  creditCardExpYear: string;
  brainTreePaymentType: string;
  brainTreeLenderProgramCode: string;
}

export interface ACHPaymentInformation {
  participantId: string;
  companyCode: string;
  noteIds: string;
  paymentAmount: number;
  paymentDueDay: number;
  bankAccountNumber: string;
  bankAccountType: string;
  bankRoutingNumber: string;
  fullName: string;
  addressLine1: string;
  city: string;
  state: string;
  zipCode: string;
  userName: string;
  paymentRef: string;
  checkPaymentId: string;
}

export interface BraintreeCreditCardPaymentReturn {
  transactionResponseResult: number;
  emailProcessingResult: number;
  transactionResponseMessage: string;
  confirmationCode: string;
}

export enum PaymentType {
  CreditCard = 1,
  PayPal = 2,
  GooglePay = 3,
  ApplePay = 4,
  ElectronicCheck = 99
}

export enum BankAccountType {
  Checking = 1,
  Savings = 2
}

export interface GooglePayConfig {
  isTestEnvironment: boolean;                           // 'true TEST or false 'PRODUCTION' refer to Google documentation
  googleMerchantId: string;                             // Requried when in Production; Merchant Id from Google
  testNonce: string;                                    // Braintree test nonce for testing
}

export interface ApplePayConfig {
  version: number;
  label: string;
  testNonce: string;
}

export interface QPaymentConfirmationDialogData {
  dialogTitle: string;
  paymentOk: boolean;
  paymentError: string;
  paymentDetail: PaymentDetail;
}

export interface PaymentDetail {
  participantId: string;
  noteIds: string;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  paymentAmount: number;
  paymentDueDay: number;
  loanProgram: string;
  servicingCompany: string;
  paymentType: PaymentType;
  bankRoutingNumber: string;
  bankAccountNumber: string;
  bankAccountConfirmNumber: string;
  bankAccountType: BankAccountType;
  userName: string;
  paymentRef: string;
  checkPaymentId: string;
  confirmationCode: string;
  responseCode: string;
  responseMessage: string;

  /* Braintree tokenized payload */
  nonce: string;
  deviceData: string;
  partiFirstName: string;
  partiLastName: string;
  partiEmail: string;
  creditCardBin: string;
  creditCardType: string;
  lastFourCreditCard: string;
  creditCardExpMonth: string;
  creditCardExpYear: string;
  brainTreePaymentType: string;
  brainTreeLenderProgramCode: string;
}

export interface PaymentAddress {
  participantId: string;
  noteIds: string;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  country: string;
  state: string;
  zipCode: string;
  acceptCreditCardFlag: boolean;
}

export interface BrainTreeClientToken {
  clientToken: string;
}

export interface BraintreeCustomerCreditCardInfo {
  customerId: string;
  creditCardType: number;
  creditCardTypeDesc: string;   // Description from tokenization or retrieved from vault (Transformed from number)
  lastFourCreditCard: string;
  creditCardExpDate: string;
  maskedCreditCardNumber: string;
}

// Credit card types defined after tokenization (Vaulted types are numeric)
export enum BraintreeCreditCardType {
  Visa = "Visa",
  MasterCard = "MasterCard",
  AmericanExpress = "American Express",
  Discover = "Discover",
}
